import { render } from "./ApplicationSuccessCard.vue?vue&type=template&id=008931a2"
import script from "./ApplicationSuccessCard.vue?vue&type=script&lang=js"
export * from "./ApplicationSuccessCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\employment\\candidate.dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__